export const OPEN_USER_DETAIL = "OPEN_USER_DETAIL";

export const CLOSE_USER_DETAIL = "CLOSE_USER_DETAIL";
